import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { useGlobalContext } from './context/context';
import Loading from './components/Loding/Loading';
import axios from 'axios';
import SectionsAndChapters from './components/ComprehensiveRules/SectionsAndChapters/SectionsAndChapters';

// Rate limiting configuration
const axiosInstance = axios.create();
axiosInstance.interceptors.response.use(null, async (error) => {
  if (error.response?.status === 429) {
    const retryAfter = error.response.headers['retry-after'] || 5;
    await new Promise((resolve) => setTimeout(resolve, retryAfter * 1000));
    return axiosInstance(error.config);
  }
  return Promise.reject(error);
});

// Implement retry queue
const retryQueue = [];
let isRetrying = false;

const processQueue = async () => {
  if (isRetrying) return;
  isRetrying = true;

  while (retryQueue.length) {
    const request = retryQueue.shift();
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000)); // 1 second delay between requests
      await request();
    } catch (error) {
      console.error('Retry failed:', error);
    }
  }

  isRetrying = false;
};

// Lazy loaded components with retry logic
const lazyLoadWithRetry = (importFn) => {
  return lazy(() => {
    const attempt = () =>
      importFn().catch((error) => {
        if (error.response?.status === 429) {
          return new Promise((resolve) => {
            retryQueue.push(() => attempt().then(resolve));
            processQueue();
          });
        }
        throw error;
      });
    return attempt();
  });
};

// Update component imports to use retry logic
// const NewLogin = lazyLoadWithRetry(() => import('./components/Login/NewLogin'));
// const Layout = lazyLoadWithRetry(() => import('./Layout'));
// ... apply to other components
// Lazy loaded components
const NewLogin = lazyLoadWithRetry(() => import('./components/Login/NewLogin'));
const Layout = lazyLoadWithRetry(() => import('./Layout'));
const Home = lazyLoadWithRetry(() => import('./components/MainPage/Home'));
const AdvanceSearch = lazyLoadWithRetry(() =>
  import('./components/AdvanceSearch/AdvanceSearch')
);
const ViewText = lazyLoadWithRetry(() =>
  import('./components/ViewText/ViewText')
);
const ViewTextcopy = lazyLoadWithRetry(() =>
  import('./components/ViewText/ViewTextcopy')
);
const MapIran = lazyLoadWithRetry(() => import('./components/MapIran/MapIran'));
const RevisionList = lazyLoadWithRetry(() =>
  import('./components/RevisionList/RevisionList')
);
const ThematicList = lazyLoadWithRetry(() =>
  import('./components/ThematicList/ThematicList')
);
const ViewNews = lazyLoadWithRetry(() => import('./components/News/ViewNews'));
const ComprehensiveRules = lazyLoadWithRetry(() =>
  import('./components/ComprehensiveRules/ComprehensiveRules')
);
const ExecutiveDevices = lazyLoadWithRetry(() =>
  import('./components/ExecutiveDevices/ExecutiveDevices')
);
const ApprovalAuthorities = lazyLoadWithRetry(() =>
  import('./components/ApprovalAuthorities/ApprovalAuthorities')
);
const CreateBook = lazyLoadWithRetry(() =>
  import('./components/ComprehensiveRules/CreateBook')
);
const Login = lazyLoadWithRetry(() => import('./components/Login/Login'));
const LawList = lazyLoadWithRetry(() => import('./components/ComprehensiveRules/LawList'));

const AppRoutes = () => (
  <Routes>
    <Route path='login' element={<NewLogin />} />
    <Route path='/' element={<Layout />}>
      <Route index element={<Home />} />
      <Route path='/AdvanceSearch' element={<AdvanceSearch />} />
      <Route path='/ViewText/:id' element={<ViewTextcopy />} />
      {/* <Route path='/ViewText/:id' element={<ViewText />} /> */}
      <Route path='/MapIran' element={<MapIran />} />
      <Route path='/RevisionList' element={<RevisionList />} />
      <Route path='/ThematicList' element={<ThematicList />} />
      <Route path='/blog/:id' element={<ViewNews />} />
      <Route path='/ComprehensiveRulesList' element={<LawList/>} />
      <Route path='/ComprehensiveRulesList/:id/:name' element={<ComprehensiveRules />} />
      <Route path='/ComprehensiveRulesList/:id/' element={<SectionsAndChapters />} />
      <Route path='/ExecutiveDevices' element={<ExecutiveDevices />} />
      <Route path='/ApprovalAuthorities' element={<ApprovalAuthorities />} />
    </Route>
    <Route path='/Createbook' element={<CreateBook />} />
  </Routes>
);

function App() {
  const { edame } = useGlobalContext();

  return (
    <Suspense fallback={<Loading />}>
      {edame ? <AppRoutes /> : <Login />}
    </Suspense>
  );
}

export default App;
